import { supabase } from '@/integrations/supabase/client';

export const getMinistryLogo = async (): Promise<string> => {
  // جلب شعار الوزارة من المحتوى المحفوظ
  let ministryLogoUrl = '/lovable-uploads/9af71c79-dc3c-4b30-b0d5-466d18153e1e.png'; // الشعار الافتراضي
  
  try {
    const { data: logoData } = await supabase
      .from('site_content')
      .select('content, image_url')
      .eq('content_type', 'ministry_logo')
      .single();
    
    if (logoData?.content && typeof logoData.content === 'object' && logoData.content !== null && 'url' in logoData.content) {
      ministryLogoUrl = logoData.content.url as string;
    } else if (logoData?.image_url) {
      ministryLogoUrl = logoData.image_url;
    }
  } catch (error) {
    console.error('استخدام الشعار الافتراضي:', error);
  }
  
  return ministryLogoUrl;
};

// تحويل الأرقام الإنجليزية إلى هندية
export const convertToArabicNumbers = (text: string): string => {
  const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  return text.replace(/\d/g, (digit) => arabicNumbers[parseInt(digit)]);
};

export const getCurrentDate = (): string => {
  try {
    const hijriFormatter = new Intl.DateTimeFormat('ar-SA-u-ca-islamic-umalqura', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    const hijriDate = hijriFormatter.format(new Date());
    return convertToArabicNumbers(hijriDate);
  } catch (error) {
    // إذا فشل التحويل، استخدم التاريخ الميلادي مع أرقام هندية
    const fallbackDate = new Date().toLocaleDateString('ar-SA');
    return convertToArabicNumbers(fallbackDate);
  }
};

// تحويل التاريخ إلى الهجري بأرقام هندية للاستخدام في PDF
export const formatHijriDateForPDF = (date: Date): string => {
  try {
    // console.log('🔄 تحويل التاريخ:', date.toISOString());
    // console.log('🔄 تحويل التاريخ:', date);
    // console.log('🔄 تحويل التاريخ:', date.toDateString());

    // استخدام Intl.DateTimeFormat للحصول على تاريخ هجري دقيق
    const hijriFormatter = new Intl.DateTimeFormat('ar-SA-u-ca-islamic-umalqura', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    
    const parts = hijriFormatter.formatToParts(date);
    const day = parts.find(part => part.type === 'day')?.value || '01';
    const month = parts.find(part => part.type === 'month')?.value || '01';
    const year = parts.find(part => part.type === 'year')?.value || '1446';
    
    // console.log('📅 أجزاء التاريخ الهجري:', { day, month, year });
    
    // تحويل الأرقام إلى هندية
    const arabicDay = convertToArabicNumbers(day);
    const arabicMonth = convertToArabicNumbers(month);
    const arabicYear = convertToArabicNumbers(year);
    
    // ترتيب: سنة/شهر/يوم (من اليمين لليسار)
    const result = `${arabicYear}/${arabicMonth}/${arabicDay} هـ`;
    // console.log('📅 النتيجة النهائية:', result);
    
    return result;
  } catch (error) {
    console.error('❌ خطأ في التحويل الهجري:', error);
    // إذا فشل التحويل، استخدم التاريخ الميلادي مع أرقام هندية
    const fallbackDate = date.toLocaleDateString('ar-SA');
    const fallbackResult = convertToArabicNumbers(fallbackDate);
    console.log('🔄 استخدام البديل:', fallbackResult);
    return fallbackResult;
  }
};

export const getStatusInfo = (absenceDays: number): { status: string; statusClass: string } => {
  let status = 'طبيعي';
  let statusClass = 'status-normal';
  
  if (absenceDays >= 5) {
    status = 'تحذير شديد';
    statusClass = 'status-severe';
  } else if (absenceDays >= 4) {
    status = 'تحذير عالي';
    statusClass = 'status-high';
  } else if (absenceDays >= 3) {
    status = 'تحذير متوسط';
    statusClass = 'status-medium';
  } else if (absenceDays >= 2) {
    status = 'تنبيه';
    statusClass = 'status-warning';
  }
  
  return { status, statusClass };
};